import { render, staticRenderFns } from "./PayPanelBottom.vue?vue&type=template&id=53209f5c&scoped=true"
import script from "./PayPanelBottom.vue?vue&type=script&lang=js"
export * from "./PayPanelBottom.vue?vue&type=script&lang=js"
import style0 from "./PayPanelBottom.vue?vue&type=style&index=0&id=53209f5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53209f5c",
  null
  
)

export default component.exports